import React from "react";

import {
    Row,
    Col,
    Badge
} from "react-bootstrap"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPhone, faUsers, faLocationArrow } from "@fortawesome/free-solid-svg-icons"

import Map from "../Map"

const geoJSON = (data) => {
    const { locations, contact } = data;

    const features = {
        type: "FeatureCollection",
        features: locations
            .filter((f) => f.features.length > 0)
            .map((loc, index) => (
                {
                    type: "Feature",
                    geometry: loc.features[0].geometry,
                    //bbox: loc.features[0].bbox,
                    properties: {
                        id: `59c0c8e322f3375db4d8912${index}`,
                        index: index,
                        isActive: loc.headquarters,
                        //logo: "http://placehold.it/32x32",
                        //image: "photo-1426122402199-be02db90eb90.jpg",
                        link: "#",
                        url: "#",
                        name: `${loc.location_city}, ${loc.location_country?.label}`,
                        //subtitle: "Entire apartment",
                        email: contact.contact_email,
                        employee: loc.location_size?.label,
                        //person: "John",
                        //avatar: "img/avatar/avatar-7.jpg",
                        phone: loc.location_phone,
                        address: `${loc.location_street}, ${loc.location_city}, ${loc.location_country?.label}, ${loc.location_zip}`,
                        about: loc.features[0].properties.display_name,
                        tags: ["magna", "culpa"]
                    }
                }
            ))

    }

    return features
}


//--
const CompanyLocationCol = (props) => {
    const loc = props;
    return (
        <Col key={loc.location.location_city} xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0">
            <div className="label-heading">
                {loc.location.location_country?.label}
            </div>
            <p className="text-sm fw-bold">
                {loc.location.location_city}
            </p>
            <div className="d-flex text-sm text-muted mb-3">
                <FontAwesomeIcon icon={faLocationArrow} className="fa-fw me-2" />
                <div className="mt-n1">
                    {loc.location?.location_zip.length > 1 ? (
                        `${loc.location.location_street}, ${loc.location.location_zip}`
                    )
                        : (`${loc.location.location_street}`)
                    }
                </div>
            </div>
            <p className="text-sm text-muted">
                <FontAwesomeIcon
                    icon={faUsers}
                    className="fa-thin me-2"
                />
                {loc.location.location_size?.label}
            </p>
            {(loc.location.location_phone.length > 5) && (
                <p className="text-sm text-muted">
                    <FontAwesomeIcon
                        icon={faPhone}
                        className="fa-fw me-2"
                    />
                    {loc.location.location_phone}
                </p>
            )
            }
        </Col>
    )
}


//--
const CompanyLocation = (data) => {
    const locations = data.data;

    return (
        <div id="location" className="text-block">
            <h4 className="mb-4">Location</h4>
            <Row>
                {
                    locations.locations.map((item, index) => (
                        <CompanyLocationCol key={index} location={item} />
                    )
                    )}
            </Row>
            {locations.locations.filter((f) => f.features.length > 0).length > 0 && (
                <div className="map-wrapper-450 mb-3">
                    <Map
                        className="h-100"
                        //center={[40.732346, -74.0014247]}
                        //circlePosition={[40.732346, -74.0014247]}
                        //circleRadius={500}
                        popupVenue
                        zoom={14}
                        geoJSON={geoJSON(locations)}
                    />
                </div>
            )}
        </div>
    )
}

export default CompanyLocation